import { render, staticRenderFns } from "./BottomSheets.vue?vue&type=template&id=3fb7feb5&"
import script from "./BottomSheets.vue?vue&type=script&lang=ts&"
export * from "./BottomSheets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports